import Urls from '../urls';

/**
 * 각 상품 블록에 있는 관심 상품 담기 버튼 초기화
 */
export function initialize() {
    $(document)
		.on('click', '.box__item-info .icon--like', function (e) {
			e.preventDefault();
			addFavoriteItem($(e.currentTarget).closest('.box__item-info'))
        })
}

/**
 * 관심 상품 담기 액션
 * @param {*} $boxItemInfos - 관심상품 담을 상품 블록(div.box__item-info)
 */
export function addFavoriteItem($boxItemInfos) {
    const parameter = "itemNos=" + $boxItemInfos.data("itemno");
    const $favoriteButton = $boxItemInfos.find('[data-button-type=like]');
	return addFavoriteItemAsync(parameter).then(response => {
        var params = {};
        if( $favoriteButton.hasClass('on') ){
            params = {target:$favoriteButton, status:false};
        } else {
            params = {target:$favoriteButton, status:true};
        }
        GMARKET.UI.APP.HOMESHOPPING.COMMON.toggleLike(params);
	})
}

window.addFavoriteItemAsync = addFavoriteItemAsync
function addFavoriteItemAsync(parameter) {
	console.log('[addFavoriteItemAsync] sent ', parameter)
	return new Promise((resolve, reject) => $.ajax({
		url: "/Common/AddFavoriteItems?" + parameter,
		type: "GET",
		xhrFields: { withCredentials: true }
	}).then(response => {
		console.log('[addFavoriteItemAsync] received ', response)
		if (response.result == "0") {
			return resolve(response)
		} else {
			if (JSON.stringify(response)) {
                alert(response.msg);
                if (response.result == -100) {
                    location.href = Urls.LoginUrl + location.href;
                }                
			}
			return reject(response)
		}
	}))
}

/*
function userIsMember() {
	return document.cookie.indexOf('isMember=MEM') !== -1
}
*/


// WEBPACK FOOTER //
// ./src/components/product-blocks.js